export const environment = {
  production: false,
  apiUrl: 'https://api.staging.kiubostudios.com/api/',
  pdfApiUrl: 'https://pdf-api.staging.kiubostudios.com/api/v1/pdfs/',
  communityUrl: 'https://community.kiubostudios.com/',
  socialAuth: {
    googleClientId: '',
    facebookAppId: '',
  },
};
